export default __webpack_public_path__ + "static/aws-deepracer-img-3-c4510828533028d1b17ce26551c849cc.jpg";